import React, { useEffect, useState } from 'react';
import Loading from '../../loading/Loading';
import TableLayout, { TD, inputSx, selectSx } from '../../ui/TableLayout';
import { EditBtn, DeleteBtn, Actions } from '../../ui/ActionButtons';
import Apis from '../../Apis';
import axios from 'axios';
import { FiPrinter } from 'react-icons/fi';
import Comprovante from '../../comprovante/Comprovante';

const today = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};
const firstOfMonth = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`;
};

const COLS      = ['Número', 'Tipo', 'Data', 'Cliente', 'Valor', 'Ações'];
const headers   = () => ({ 'Content-Type': 'application/json', Authorization: localStorage.getItem('token') });

const TIPO_MAP = { '1': 'Venda', '2': 'Troca', '3': 'Compra' };
const TIPO_COLOR = {
  '1': { bg: 'rgba(82,148,181,0.12)',  color: '#162e3c' },
  '2': { bg: 'rgba(245,158,11,0.1)',  color: '#b45309' },
  '3': { bg: 'rgba(16,185,129,0.1)',  color: '#047857' },
};

export default function ListaPedido() {
  const t = today();
  const [dataIni, setDataIni]       = useState(localStorage.getItem('@adm_pedido_data_ini_pedido') || firstOfMonth());
  const [dataFim, setDataFim]       = useState(localStorage.getItem('@adm_pedido_data_fim_pedido') || t);
  const [search, setSearch]         = useState('');
  const [perPage, setPerPage]       = useState(25);
  const [tipoPedido, setTipoPedido] = useState('-1');
  const [vendedor, setVendedor]     = useState('');
  const [representantes, setRepresentantes] = useState([]);
  const [data, setData]             = useState([]);
  const [loading, setLoading]       = useState(true);
  const [comprovanteId, setComprovanteId] = useState(null);

  const fetchData = (ini = dataIni, fim = dataFim, s = search, pp = perPage, tp = tipoPedido, vend = vendedor) => {
    setLoading(true);
    const body = { data_inicial: ini, data_final: fim, pesquisa: s, qtd_registros: pp, ident_operacao: tp };
    if (vend !== '') body.representante_id = vend;
    axios.post(Apis.urlListarPedidos, body, { headers: headers() })
      .then(res => setData(res.data.registros || []))
      .catch(err => alert(err.response?.data?.retorno?.mensagem || 'Erro ao buscar pedidos.'))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchData();
    axios.get(`${Apis.urlListarRepresentantes}?pesquisa=&status=-1&qtd_registros=1000`, { headers: headers() })
      .then(res => setRepresentantes(res.data.registros || []))
      .catch(() => {});
  }, []); // eslint-disable-line

  const handleIni = (v) => { setDataIni(v); localStorage.setItem('@adm_pedido_data_ini_pedido', v); };
  const handleFim = (v) => { setDataFim(v); localStorage.setItem('@adm_pedido_data_fim_pedido', v); };
  const handlePerPage = (val) => { setPerPage(val); fetchData(dataIni, dataFim, search, val); };

  const Toolbar = (
    <>
      <div style={{ display: 'flex', alignItems: 'center', border: '1px solid #d1d5db', borderRadius: 4, overflow: 'hidden', background: '#fff', height: 34 }}>
        <input type="date" value={dataIni}
          onChange={e => { const v = e.target.value; handleIni(v); }}
          style={{ border: 'none', outline: 'none', padding: '0 8px', fontSize: 13, fontFamily: 'inherit', color: '#111827', background: 'transparent', height: '100%', width: 132 }} />
        <input type="date" value={dataFim}
          onChange={e => { const v = e.target.value; handleFim(v); }}
          style={{ border: 'none', outline: 'none', padding: '0 8px', fontSize: 13, fontFamily: 'inherit', color: '#111827', background: 'transparent', height: '100%', width: 132, borderLeft: '1px solid #e5e7eb' }} />
        <button onClick={() => fetchData()}
          style={{ border: 'none', borderLeft: '1px solid #e5e7eb', height: '100%', padding: '0 14px', background: '#f3f4f6', color: '#374151', fontSize: 12, fontWeight: 600, fontFamily: 'inherit', cursor: 'pointer', whiteSpace: 'nowrap', transition: 'background 0.15s' }}
          onMouseEnter={e => e.currentTarget.style.background = '#e5e7eb'}
          onMouseLeave={e => e.currentTarget.style.background = '#f3f4f6'}>
          Buscar
        </button>
      </div>
      <select value={tipoPedido}
        onChange={e => { const v = e.target.value; setTipoPedido(v); fetchData(dataIni, dataFim, search, perPage, v); }}
        style={selectSx}>
        <option value="-1">Todos os tipos</option>
        <option value="1">Venda</option>
        <option value="2">Troca</option>
        <option value="3">Compra</option>
      </select>
      <select value={vendedor}
        onChange={e => { const v = e.target.value; setVendedor(v); fetchData(dataIni, dataFim, search, perPage, tipoPedido, v); }}
        style={selectSx}>
        <option value="">Todos os representantes</option>
        {representantes.map(r => (
          <option key={r.id} value={r.id}>{r.nome}</option>
        ))}
      </select>
    </>
  );

  if (loading) return <Loading />;

  return (
    <>
      <TableLayout
        title="Lista de Pedidos"
        icon={null}
        count={data.length}
        columns={COLS}
        search={{ value: search, onChange: setSearch, placeholder: 'Buscar por cliente ou número…', onSubmit: () => fetchData() }}
        pagination={{ value: perPage, onChange: handlePerPage }}
        toolbar={Toolbar}
        fab={{ show: true, label: 'pedido', path: 'cadastrar-pedido' }}
        emptyMessage="Nenhum pedido encontrado para o período selecionado."
      >
        {data.map((c, i) => {
          const tipo = String(c.ident_operacao);
          const tipoStyle = TIPO_COLOR[tipo] || { bg: 'rgba(100,116,139,0.1)', color: '#475569' };
          return (
            <tr key={c.id}
              style={{ backgroundColor: i % 2 === 0 ? '#fff' : '#f8fafc' }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#eff6ff')}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = i % 2 === 0 ? '#fff' : '#f8fafc')}
            >
              <TD>
                <span style={{ display: 'inline-block', padding: '2px 12px', borderRadius: 4, background: '#edf6fb', color: '#5294b5', fontSize: 12, fontWeight: 700 }}>
                  #{c.numero}
                </span>
              </TD>
              <TD>
                <span style={{ display: 'inline-block', padding: '2px 12px', borderRadius: 40, background: tipoStyle.bg, color: tipoStyle.color, fontSize: 11, fontWeight: 600 }}>
                  {TIPO_MAP[tipo] || '—'}
                </span>
              </TD>
              <TD>{c.data.split('-').reverse().join('/')}</TD>
              <TD left uppercase>{c.participante.nome}</TD>
              <TD>
                <span style={{ fontSize: 13, fontWeight: 700, color: '#10b981' }}>
                  R$ {(parseFloat(c.valor) - parseFloat(c.desconto)).toFixed(2)}
                </span>
              </TD>
              <TD>
                <Actions>
                  <button
                    title="Imprimir comprovante"
                    onClick={() => setComprovanteId(c.id)}
                    style={{
                      width: 30, height: 30, border: 'none', borderRadius: 6, cursor: 'pointer',
                      color: '#1e3a4c', background: 'rgba(30,58,76,0.08)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      transition: 'background 0.15s',
                    }}
                    onMouseEnter={e => e.currentTarget.style.background = 'rgba(30,58,76,0.18)'}
                    onMouseLeave={e => e.currentTarget.style.background = 'rgba(30,58,76,0.08)'}
                  >
                    <FiPrinter size={14} />
                  </button>
                  <EditBtn to={`/alterar-pedido/${c.id}`} />
                  <DeleteBtn url={Apis.urlDeletarPedidoVenda} id={c.id} redirect="listar-pedidos" component="Pedido" texto={`Deseja realmente excluir o pedido ${c.numero}`} />
                </Actions>
              </TD>
            </tr>
          );
        })}
      </TableLayout>

      {comprovanteId && (
        <Comprovante pedidoId={comprovanteId} onClose={() => setComprovanteId(null)} />
      )}
    </>
  );
}
